module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cg2F6"))).then(() => parcelRequire('1iHdE'));